import { render, staticRenderFns } from "./editEducationClassModal.vue?vue&type=template&id=3e3fe222&"
import script from "./editEducationClassModal.vue?vue&type=script&lang=js&"
export * from "./editEducationClassModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports